import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLineMeasurmentToolbar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_8687_26854)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				x: .883883,
				y: 7.45058e-8,
				width: 20.9853,
				height: 6.25,
				rx: .625,
				transform: "matrix(0.707107 0.707107 0.707107 -0.707107 -0.239652 4.15149)",
				stroke: "currentColor",
				strokeWidth: 1.25
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.50049 7.47205L5.00049 4.97205",
				stroke: "currentColor",
				strokeWidth: 1.25
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.00049 9.97205L6.76826 8.20428",
				stroke: "currentColor",
				strokeWidth: 1.25
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.50049 12.472L10.0005 9.97205",
				stroke: "currentColor",
				strokeWidth: 1.25
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.0005 14.972L11.7683 13.2043",
				stroke: "currentColor",
				strokeWidth: 1.25
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.5005 17.472L15.0005 14.972",
				stroke: "currentColor",
				strokeWidth: 1.25
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8687_26854",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "currentColor",
			transform: "matrix(-1 0 0 1 20 0)"
		})
	}) })]
});
export default SvgLineMeasurmentToolbar;
